var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7627 14.3866C28.7627 21.6525 23.3784 27.6593 16.3837 28.6341C15.7297 28.7248 15.0606 28.7722 14.3813 28.7722C13.5973 28.7722 12.8274 28.7097 12.0777 28.5887C5.23013 27.4859 0 21.5466 0 14.3866C0 6.4413 6.43941 0 14.3823 0C22.3253 0 28.7647 6.4413 28.7647 14.3866H28.7627Z",
    fill: "#040742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3834 11.5519V14.6858H20.2591L19.6454 18.9075H16.3834V28.6339C15.7294 28.7246 15.0602 28.772 14.381 28.772C13.597 28.772 12.8271 28.7095 12.0774 28.5886V18.9075H8.50293V14.6858H12.0774V10.8513C12.0774 8.47234 14.0051 6.54297 16.3844 6.54297V6.54499C16.3915 6.54499 16.3975 6.54297 16.4046 6.54297H20.2601V10.1941H17.7408C16.9921 10.1941 16.3844 10.8019 16.3844 11.5509L16.3834 11.5519Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.23296cd111bf7876724bd4f4081fb052.svg";
export { ForwardRef as ReactComponent };